import * as Tgcc from './tgccGlobal';
import request from 'superagent';
import { FilterBubble } from './Components/FilterBubble';
import { profile } from 'console';

let authToken: string = '';

export function setAuthToken(token: string) {
    authToken = token;
}

declare var ApiRouteBase: string;
const apiRoot: string = ApiRouteBase + '/';

////////////////////////////// Handle API Errors ////////////////////////////////////

const logError = (label: string, err: any) => {
    console.log(label, err)
}


const extractErrorMsg = (err: any) => {
    // check for string only as body
    try {
        if (typeof err.response.body === "string")
            return err.response.body;
    } catch (ex) { }

    // look for password errors
    try {
        if (err.response.body["PasswordRequiresDigit"])
            return err.response.body["PasswordRequiresDigit"];
        if (err.response.body["PasswordRequiresUpper"])
            return err.response.body["PasswordRequiresUpper"];
        if (err.response.body["PasswordRequiresNonAlphanumeric"])
            return err.response.body["PasswordRequiresNonAlphanumeric"];
        if (err.response.body["PasswordMismatch"])
            return err.response.body["PasswordMismatch"];
    } catch (ex) { }

    // check for lowercase message (e.g. API validation / business rule messages)
    try {
        var msg = err.response.body.message;
        if (msg)
            return msg;
    } catch (ex) { }

    // try looping over body properties
    try {
        for (var propertyName in err.response.body)
            return err.response.body[propertyName];
    } catch (ex) { }

    // check for error description in response body
    try {
        var msg = err.response.body.error_description;
        if (msg)
            return msg;
    } catch (ex) { }

    // check for model validation failure
    try {
        var obj = err.response.body.ModelState;
        var msg = obj[Object.keys(obj)[0]][0];
        if (msg)
            return msg;
    } catch (ex) { }

    // check for exception message in the body
    try {
        var msg = err.response.body.ExceptionMessage;
        if (msg)
            return msg;
    } catch (err) { }

    // check for exception message in the body
    try {
        var msg = err.response.body.Message;
        if (msg)
            return msg;
    } catch (err) { }

    // check for error message
    try {
        var msg = err.message;
        if (msg)
            return msg;
    } catch (ex) { }

    return err;
}

////////////////////////////// DESIGN api routes //////////////////////////////////

/** Global design text search: `designs/alldesigns/filter/{search}` (no division in path). */
const allDesignsSearchUri = (filter: string | null | undefined): string => {
    const base = apiRoot + "designs/alldesigns";
    if (filter) {
        return base + "/filter/" + encodeURI(filter);
    }
    return base;
};

export const getDesignCategories = (division: string, whenDone: (categories: string[]) => void) => {
    request('GET', apiRoot + 'designs/division/' + encodeURI(division) + '/categories').end((err: any, res: any) => {
        if (!err)
            whenDone(res.body);
    }
    );
};

export const updateEstimateStatus = (
    webOrderNumber: string,
    status: string,
    changeNotes: string,
    onSuccess: (response: any) => void,
    onError: (error: any) => void
) => {
    request
        .patch(apiRoot + 'Resources/SalesDocuments/UpdateStatus')
        .send({ webOrderNumber, status, changeNotes })
        .end((err: any, res: any) => {
            if (err) {
                logError("updateEstimateStatus:", err);
                onError(extractErrorMsg(err) || "Error updating estimate status.");
            } else {
                onSuccess(res.body);
            }
        });
};



export const getDesignCategoryDesigns = (division: string, category: string, whenDone: (categories: Tgcc.DesignCategory[]) => void) => {
    var encodedCategory: string = encodeURI(category);
    request('GET', apiRoot + 'designs/division/' + encodeURI(division) + '/categories/' + encodedCategory)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getDesignCategoryDesignsFiltered = (division: string, category: string, filter: string, whenDone: (categories: Tgcc.Design[]) => void) => {
    var encodedCategory: string = encodeURI(category);
    var encodedFilter: string = encodeURI(filter)
    request('GET', apiRoot + 'designs/division/' + encodeURI(division) + '/categories/' + encodedCategory + '/filter/' + encodedFilter)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getDesignsFiltered = (_division: string, filter: string, whenDone: (categories: Tgcc.Design[]) => void) => {
    request("GET", allDesignsSearchUri(filter))
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};


export const getDesignsByCategoryFiltered = (division: string, category: string, filter: string, whenDone: (designs: Tgcc.Design[]) => void) => {
    var urlfilter: string = encodeURI(filter);
    var urlcategory: string = encodeURI(category);
    request('GET', apiRoot + 'designs/division/' + encodeURI(division) + '/categories/' + urlcategory + '/filter/' + urlfilter)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
}

export const getDesign = (designId: string, onSuccess: (design: Tgcc.Design) => void, onError: (err: string) => void) => {
    request('GET', apiRoot + 'designs/' + encodeURI(designId))
        .end((err: any, res: any) => {
            if (err)
                onError(extractErrorMsg(err))
            else
                onSuccess(res.body);
        });
}

export const getDesignLicenses = (whenDone: (licenses: Tgcc.License[]) => void) => {
    request('GET', apiRoot + 'designs/licenses').end((err: any, res: any) => {
        if (!err)
            whenDone(res.body);
    }
    );
};

export const getDesignLicenseDesigns = (licenseId: number, whenDone: (designs: Tgcc.Design[]) => void) => {
    request('GET', apiRoot + 'designs/licenses/' + licenseId)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getDesignLicenseDesignsFiltered = (licenseId: number, filter: string, whenDone: (designs: Tgcc.Design[]) => void) => {
    var encodedFilter: string = filter ? '/filter/' + encodeURI(filter) : "";
    licenseId = licenseId ? licenseId : -1;
    var requestUri = apiRoot + 'designs/licenses/' + licenseId + encodedFilter;
    request('GET', requestUri)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getAllDesignsByFilter = (filter: string, whenDone: (designs: Tgcc.Design[]) => void) => {
    if (!filter) {
        whenDone([]);
        return;
    }
    request("GET", allDesignsSearchUri(filter))
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};
export const getAllCorpDesignsByFilter = (filter: string, whenDone: (designs: Tgcc.Design[]) => void) => {
    // Get division from localStorage (or default to 'corporate')
    const division = localStorage.getItem('division') || 'corporate';
    
    var requestUri = apiRoot + 'designs/allcorpdesigns/filter/' + encodeURI(division);
    if (filter) {
        requestUri += '/' + encodeURI(filter);
    }
    request('GET', requestUri)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body)
        })

}

export const getAllDesignsBySearchFilter = (filter: string, whenDone: (designs: Tgcc.Design[]) => void) => {
    request("GET", allDesignsSearchUri(filter))
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
}


////////////////////////// PRODUCT api routes ////////////////////////////////////////

const DefaultDivision: string = 'all';

const encodeBrand = (brand: string) => {
    if (brand) {
        brand = brand.replace('&', '_and_');
        brand = brand.replace('+', '_plus_');
    }
    var encodedBrand: string = encodeURI(brand);
    return encodedBrand;
}

export const encodeColor = (color: string) => {
    if (color) {
        color = color.replace(new RegExp('/','g'), '_slash_');
    }
    var encodedColor: string = encodeURI(color);
    return encodedColor;
}

export const getProductCategories = (division: string, whenDone: (categories: Tgcc.ProductCategory[]) => void) => {
    division = division || DefaultDivision;
    request('GET', apiRoot + 'products/division/' + encodeURI(division) + '/categories').end((err: any, res: any) => {
        if (!err)
            whenDone(res.body);
    });
};

export const getProductBrands = (division: string, whenDone: (brands: Tgcc.ProductBrand[]) => void) => {
    division = division || DefaultDivision;
    request('GET', apiRoot + 'products/division/' + encodeURI(division) + '/brands').end((err: any, res: any) => {
        if (!err)
            whenDone(res.body);
    }
    );
};

export const getProductsByCategoryBrand = (division: string, categoryId: number, brand: string, whenDone: (products: Tgcc.Product[]) => void) => {
    division = division || DefaultDivision;
    request('GET', apiRoot + 'products/division/' + encodeURI(division) + '/brands/' + encodeBrand(brand))
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getProductsByCategoryBrandFiltered = (division: string, categoryId: number, brand: string, filter: string, whenDone: (products: Tgcc.Product[]) => void) => {
    var encodedBrand: string = encodeBrand(brand);
    var encodedFilter: string = encodeURI(filter);
    division = division || DefaultDivision;
    request('GET', apiRoot + 'products/division/' + encodeURI(division) + '/categories/' + (categoryId || "0") + '/brands/' + (encodedBrand || "null") + '/filter/' + (encodedFilter || "null"))
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};

export const getSizesForStyleAndColor = (style: string, colorName: string, whenDone: (sizes: { size: string, description: string, image: string, thumbnail: string }[]) => void) => {
    request('GET', apiRoot + 'products/getSizesForStyleAndColor?style=' + encodeURI(style) + '&colorName=' + encodeURI(colorName))
        .end((err: any, res: any) => {
            if (!err) {
                console.log('Sizes Response Data:', res.body); // Log the response data
                whenDone(res.body);
            } else {
                console.error('Error fetching sizes:', err);
            }
        });
};


export const findProducts = (requestTime: number,
    division: string, categories: number[],
    brand: string[], filter: string,
    style: string, color: string,
    priceCategory: string[],
    genderAge: string[], sleeve: string[],
    styleType: string[], fabric: string[],
    weight: string[], uniqueSize: string[],
    newItem: boolean,
    favorite: boolean,
    sortOrder: string,
    whenDone: (requestTime: number, products: Tgcc.Product[]) => void) => {

    var queryCategories = new Array<number>();
    if (categories)
        categories.forEach(c => queryCategories.push(c));
    if (!queryCategories.length)
        queryCategories.push(0);  // 0 for all categories

    var encodedBrands = new Array<string>();
    if (brand)
        brand.forEach(b => encodedBrands.push(encodeBrand(b)));

    var encodedFilter: string = filter ? encodeURI(filter) : null;
    division = division || DefaultDivision;

    var sortInt = 0;
    switch (sortOrder) {
        case Tgcc.SortOrders.AtoZ: sortInt = 1; break;
        case Tgcc.SortOrders.ZtoA: sortInt = 2; break;
        case Tgcc.SortOrders.LowToHigh: sortInt = 3; break;
        case Tgcc.SortOrders.HighToLow: sortInt = 4; break;
        default: sortInt = 0; break; // unsorted
    }

    var data = {
        'Division': encodeURI(division),
        'CategoryId': queryCategories,
        'Brand': encodedBrands,
        'Style': style,
        'Filter': encodedFilter,
        'Color': color,
        'PriceCategory': priceCategory,
        'GenderAge': genderAge,
        'SleeveLength': sleeve,
        'StyleType': styleType,
        'Fabric': fabric,
        'NewProduct': newItem,
        'UniqueSize': uniqueSize,
        'Weight': weight,
        'Favorite': favorite,
        'SortOrder': sortInt
    };

    console.log('Request Data:', data); // Log the request data

    request.post(apiRoot + 'products/find')
        .send(data)
        .end((err: any, res: any) => {
            if (!err) {
                console.log('Response Data:', res.body); // Log the response data
                whenDone(requestTime, res.body);
            }
        });
};


export interface ConfirmEmailResponse {
    message:     string;
    division:    string;
    accessToken: string;
    expires:     string;
    newEmail?:   string;
  }
  
  export const confirmEmailUpdate = (
    token: string,
    onSuccess: (response: ConfirmEmailResponse) => void,
    onError:   (err: string)                => void
  ) => {
    request
      .get(`${apiRoot}Account/ConfirmEmailUpdate`)
      .query({ token })
      .end((err: any, res: any) => {
        if (err || !res.ok) {
          const errorMessage =
            res?.body?.message ||
            extractErrorMsg(err) ||
            'Failed to confirm email.';
          onError(errorMessage);
          logError('confirmEmailUpdate:', err || res.statusText);
          return;
        }
  
        // Cast the body
        const body = res.body as ConfirmEmailResponse;
  
        // **Swap in the new JWT immediately**
        setAuthToken(body.accessToken);
  
        // Forward the updated info so your component can update Redux / localStorage
        onSuccess(body);
      });
  };


export const getFilterCounts = (requestTime: number, division: string, categories: number[],
    brand: string[], filter: string,
    priceCategory: string[],
    genderAge: string[], sleeve: string[],
    styleType: string[], fabric: string[],
    weight: string[], uniqueSize: string[],
    newItem: boolean,
    favorite: boolean,
    whenDone: (requestTime: number, counts: Map<string, Map<string, number>>) => void) => {

    var queryCategories = new Array<number>();
    if (categories) categories.forEach(c => queryCategories.push(c));
    if (!queryCategories.length) queryCategories.push(0);  // 0 for all categories

    var encodedBrands = new Array<string>();
    if (brand) brand.forEach(b => encodedBrands.push(encodeBrand(b)));

    var encodedFilter: string = filter ? encodeURI(filter) : null;
    division = division || DefaultDivision;

    var data = {
        'Division': encodeURI(division),
        'CategoryId': queryCategories,
        'Brand': encodedBrands,
        'Style': null,
        'Filter': encodedFilter,
        'Color': null,
        'PriceCategory': priceCategory,
        'GenderAge': genderAge,
        'SleeveLength': sleeve,
        'StyleType': styleType,
        'Fabric': fabric,
        'NewProduct': newItem,
        'UniqueSize': uniqueSize,
        'Weight': weight,
        'Favorite': favorite,
        'SortOrder': 0
    };

    request.post(apiRoot + 'products/getfiltercounts')
        .send(data)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(requestTime, res.body);
        }
        );
};

export const getProductStyleSet = (product: Tgcc.Product, whenDone: (products: Tgcc.Product[]) => void) => {
    request('GET', apiRoot + 'products/' + encodeBrand(product.brand) + '/' + product.style)
        .end((err: any, res: any) => {
            if (!err)
                whenDone(res.body);
        });
};


export const getProduct = (brand: string, style: string, color: string, onSuccess: (product: Tgcc.Product) => void, onError: (err: string) => void) => {

    request('GET', apiRoot + 'products/brands/' + encodeBrand(brand) + '/style/' + encodeURI(style) + '/color/' + encodeColor(color))
        .end((err: any, res: any) => {
            if (!err)
                onSuccess(res.body);
        });
}


////////////////////// API Queries for User Management ///////////////////////////////

export const loginUser = (
    email: string,
    password: string,
    whenDone: (data: Tgcc.LoginData) => void,
    onError: (err: string) => void
  ) => {
    const urlemail   = encodeURIComponent(email);
    const urlpassword = encodeURI(password);
  
    // clear any old data
    Tgcc.ClearUserData();
  
    request
      .post(`${apiRoot}Account/Login`)
      .type('application/x-www-form-urlencoded')
      .send(`username=${urlemail}&password=${urlpassword}`)
      .accept('application/json')
      .end((err: any, res: any) => {
        if (err) {
          onError(extractErrorMsg(err) || "User login failed");
          logError("loginUser: ", err);
        } else {
          // persist to localStorage
          Tgcc.SaveUserData(null, res.body);
  
          // **this is the new bit**: stash the fresh token for ALL future requests
          setAuthToken(res.body.token);
  
          // now hand the LoginData back to the caller
          whenDone(res.body);
        }
      });
  };export function fetchAccountInfo(
    email: string,
    successCallback: (accountInfo: {
      firstName?: string;
      lastName?: string;
      address?: string;
      city?: string;
      state?: string;
      zip?: string;
      phone?: string;
      smsAllowed?: boolean;
    }) => void,
    errorCallback: (error: string) => void
  ) {
    const url = `/api/account/fetchAccountInfo?email=${encodeURIComponent(email)}`;
  
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch account info: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => {
        successCallback({
          firstName: data.firstName,
          lastName: data.lastName,
          address: data.address,
          city: data.city,
          state: data.state,
          zip: data.zip,
          phone: data.phone,
          smsAllowed: data.smsAllowed,
        });
      })
      .catch((error) => {
        errorCallback(error.message || 'Failed to fetch account info');
      });
  }

  
export const setupAccount = (
    email: string,
    token: string,
    division: string,
    password: string,
    onSuccess: () => void,
    onError: (err: string) => void
) => {
    const data = {
        email,
        token,
        division,
        password,
    };

    request.post(apiRoot + 'Account/Setup')
        .type('application/json')
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                logError("setupAccount:", err);
                onError(extractErrorMsg(err) || "Account setup failed");
            } else {
                onSuccess();
            }
        });
};

export const completeAccountSetup = (
    data: {
      email: string;
      token: string;
      // Passwordless: password fields optional for backward compatibility
      password?: string;
      confirmPassword?: string;
      firstName: string;
      lastName: string;
      address1: string;
      address2?: string;
      city: string;
      state: string;
      zip: string;
      phone: string;
      smsAllowed: boolean;
      // Optional extended profile fields
      schoolOrBusiness?: string;
      organization?: string;
      studentGroup?: string;
      group?: string;
      buyer?: string;
      marketingOptIn?: boolean;
    },
    onSuccess: (message: string) => void,
    onError: (error: string) => void
  ) => {
    request
      .post(apiRoot + 'Account/Setup') // The endpoint for completing account setup
      .send(data)
      .set('Content-Type', 'application/json')
      .end((err: any, res: any) => {
        if (err || !res.ok) {
          console.error('completeAccountSetup Error: ', err || res.text);
          onError(err?.response?.text || 'Failed to complete account setup');
        } else {
          onSuccess(res.text || 'Account setup successful');
        }
      });
  };


export const updateUser = (
    login: Tgcc.LoginData,
    user: Tgcc.UserInfo,
    whenDone: (data: Tgcc.UserInfo) => void,
    onError: (err: any) => void
  ) => {
    // 1) determine division based on URL path
    const path = window.location.pathname.toLowerCase();
    let division = 'corporate';
    if (path.includes('/campus')) division = 'campus';
    else if (path.includes('/indigo')) division = 'indigo';
  
    // 2) build payload
    const payload = { ...user, division };
    console.log('Updating user with payload:', payload);
  
    // 3) send request
    request
      .post(`${apiRoot}Account/UpdateUser`)
      .set('Authorization', `Bearer ${authToken}`)
      .set('impersonate', login.impersonate || '')
      .send(payload)
      .end((err: any, res: any) => {
        // 4) handle "already pending" conflict
        if (res && res.status === 409 && res.body && res.body.message) {
          onError(res.body.message);
          // do NOT call whenDone here, so no popup
          return;
        }
  
        // 5) handle any other error
        if (err || !res.ok) {
          let msg = extractErrorMsg(err) || res.statusText || 'User update failed';
          if (res && res.body && typeof res.body.message === 'string') {
            msg = res.body.message;
          }
          console.error('updateUser error:', msg, err);
          onError(msg);
          return;
        }
  
        // 6) success: pass updated profile back
        const updated: Tgcc.UserInfo = res.body;
        console.log('updateUser success, returned:', updated);
        whenDone(updated);
      });
  };
  
  
  

export const updateUserAddress = (loginData, addressData, onSuccess, onError) => {
    request.post(apiRoot + 'Account/UpdateAddress')
        .send(addressData)
        .set('Authorization', 'Bearer ' + loginData.token)
        .end((err, res) => {
            if (err || !res.ok) {
                onError(err);
            } else {
                onSuccess(res.body);
            }
        });
};

export const updateHeroLoginTimestamp = (loginData, userEmail, onSuccess, onError) => {
    request.post(apiRoot + 'Account/UpdateHeroLoginTimestamp')
        .send({ userEmail: userEmail })
        .set('Authorization', 'Bearer ' + loginData.token)
        .end((err, res) => {
            if (err) {
                let errorMessage = "Failed to update Hero Login Timestamp";
                if (err.response && err.response.body && err.response.body.error) {
                    errorMessage = err.response.body.error;
                }
                onError(errorMessage);
            } else if (res.ok) {
                onSuccess(res.body);
            }
        });
};

export const updateEstimateWithToken = (
    token: string,
    status: string,
    changeNotes: string | null,
    onSuccess: (response: any) => void,
    onError: (error: any) => void
) => {
    request
        .patch(apiRoot + 'Resources/SalesDocuments/UpdateWithToken')
        .send({ token, status, changeNotes })
        .end((err: any, res: any) => {
            if (err) {
                logError("updateEstimateWithToken:", err);
                onError(extractErrorMsg(err) || "Error updating estimate status.");
            } else if (
                res.body &&
                typeof res.body.message === "string" &&
                res.body.message.includes("can no longer be approved")
            ) {
                // API returned 200 but with business-rule error (e.g. estimate changed by account manager)
                onError(res.body.message);
            } else {
                onSuccess(res.body);
            }
        });
};

/** Response body from GET Resources/SalesDocuments/GetWebOrderFromToken */
export interface WebOrderFromToken {
    webOrderNumber: string;
    documentNumber?: number;
    qbCustomerId?: string;
    customerEmail?: string;
    paymentTerms?: string | null;
    totalOrderAmount?: number;
    /** Present once the token endpoint returns it. Null or blank means the estimate has no ship-to. */
    shippingAddress?: string | null;
    /** True when the archived estimate PDF can be opened for this token. */
    estimatePdfAvailable?: boolean;
}

export const estimatePdfFromTokenUrl = (token: string): string =>
    `${apiRoot}Resources/SalesDocuments/EstimatePdf?token=${encodeURIComponent(token)}`;

export const fetchWebOrderFromToken = (
    token: string,
    onSuccess: (order: WebOrderFromToken) => void,
    onError: (error: string) => void
) => {
    request
        .get(`${apiRoot}Resources/SalesDocuments/GetWebOrderFromToken`)
        .query({ token }) // Pass token as query param
        .end((err, res) => {
            if (err || !res.ok) {
                console.error("fetchWebOrderFromToken: Error fetching webOrderNumber", err);
                onError("Invalid or expired token.");
                return;
            }

            if (!res.body || !res.body.webOrderNumber) {
                console.warn("fetchWebOrderFromToken: No webOrderNumber returned.");
                onError("Order not found.");
                return;
            }

            onSuccess(res.body as WebOrderFromToken);
        });
};



export const logoutUser = (login: Tgcc.LoginData, whenDone: () => void) => {
    Tgcc.ClearUserData();
    if (whenDone)
        whenDone();
    request.post(apiRoot + 'Account/Logout')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .end((err: any, res: any) => {
            if (err)
                logError("logoutUser:", err);
            else if (whenDone)
                whenDone();
        });
}

export const checkEmailAvailability = (email, whenDone, onError) => {
    request.get(`${apiRoot}Account/CheckEmail?email=${encodeURIComponent(email)}`)
        .send({ email: email })
        .set('Content-Type', 'application/json')
        .end((err, res) => {
            if (err || !res.ok) {
                if (onError) {
                    onError(extractErrorMsg(err) || 'Error checking email availability.');
                }
                logError("checkEmailAvailability: ", err);
            } else {
                whenDone(res.body.isInUse);
            }
        });
}




export const registerUser = (user: Tgcc.UserInfo, password: string, confirmPassword: string, whenDone: (data: any) => void, onError: (data: any) => void) => {
    var data = Object.assign({}, user, { Password: password, ConfirmPassword: confirmPassword });
    request.post(apiRoot + 'Account/Register')
        .type('application/json')
        .send(data)
        .accept('application/json')
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || "User registration failed");
                logError("registerUser: ", err);
            } else {
                whenDone(res.body);
            }
        });
}

// Passwordless registration
export const registerUserPasswordless = (
    user: Tgcc.UserInfo,
    otpCode: string,
    whenDone: (data: any) => void,
    onError: (data: any) => void
) => {
    const payload: any = { ...user, otpCode };
    request.post(apiRoot + 'Account/RegisterPasswordless')
        .type('application/json')
        .send(payload)
        .accept('application/json')
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || "User registration failed");
                logError("registerUserPasswordless: ", err);
            } else {
                whenDone(res.body);
            }
        });
}

// Request registration OTP (email-only)
export const requestRegistrationOtp = (
    email: string,
    whenDone: (data: { ok: boolean; resendAfterSeconds?: number }) => void,
    onError: (err: string) => void
) => {
    request.post(apiRoot + 'Account/RegisterOtpRequest')
        .type('application/json')
        .send({ email })
        .accept('application/json')
        .end((err: any, res: any) => {
            if (err || !res?.ok) {
                onError(extractErrorMsg(err) || 'Failed to send verification code');
                logError('requestRegistrationOtp:', err || res?.statusText);
            } else {
                whenDone(res.body || { ok: true });
            }
        });
}

// Login OTP request
export const requestLoginOtp = (
    email: string,
    whenDone: (data: { ok: boolean; resendAfterSeconds?: number }) => void,
    onError: (err: string) => void
) => {
    request.post(apiRoot + 'Account/LoginOtpRequest')
        .type('application/json')
        .send({ email })
        .accept('application/json')
        .end((err: any, res: any) => {
            if (err || !res?.ok) {
                onError(extractErrorMsg(err) || 'Failed to send login code');
                logError('requestLoginOtp:', err || res?.statusText);
            } else {
                whenDone(res.body || { ok: true });
            }
        });
}

// Login OTP verification
export const verifyLoginOtp = (
    email: string,
    otpCode: string,
    whenDone: (data: Tgcc.LoginData) => void,
    onError: (err: string) => void
) => {
    request.post(apiRoot + 'Account/LoginOtpVerify')
        .type('application/json')
        .send({ email, otpCode })
        .accept('application/json')
        .end((err: any, res: any) => {
            if (err || !res?.ok) {
                onError(extractErrorMsg(err) || 'Invalid or expired code');
                logError('verifyLoginOtp:', err || res?.statusText);
            } else {
                // persist & set token
                Tgcc.SaveUserData(null, res.body);
                setAuthToken(res.body.token);
                whenDone(res.body as Tgcc.LoginData);
            }
        });
}

// CSR creates a managed customer (no OTP). Admin/CSR only.
export const createManagedCustomer = (
  email: string,
  division: 'Collegiate' | 'Corporate' | 'Indigo',
  profile: any | undefined,
  csrEmail: string | undefined,
  whenDone: (data: { id: string; email: string; division: string; setupLink?: string }) => void,
  onError: (err: string) => void
) => {
  const payload = Object.assign({ email, division, CsrCreated: true, csrEmail: csrEmail || '' }, profile || {});
  request.post(apiRoot + 'Account/RegisterCsr')
    .type('application/json')
    .send(payload)
    .accept('application/json')
    .end((err: any, res: any) => {
      if (err || !res?.ok) {
        onError(extractErrorMsg(err) || 'Failed to create customer');
        logError('createManagedCustomer:', err || res?.statusText);
      } else {
        whenDone(res.body);
      }
    });
}

// CSR starts an impersonation session as the created customer
export const impersonateCustomer = (
  customerId: string,
  whenDone: (data: { token: string }) => void,
  onError: (err: string) => void
) => {
  request.post(`${apiRoot}admin/customers/${encodeURIComponent(customerId)}/impersonate`)
    .type('application/json')
    .accept('application/json')
    .end((err: any, res: any) => {
      if (err || !res?.ok) {
        onError(extractErrorMsg(err) || 'Failed to start impersonation');
        logError('impersonateCustomer:', err || res?.statusText);
      } else {
        whenDone(res.body);
      }
    });
}

export const getUserInfo = (login: Tgcc.LoginData, whenDone: (data: Tgcc.UserInfo) => void) => {
    request.post(apiRoot + 'Account/UserInfo')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("getUserInfo: ", err);
            } else {
                whenDone(res.body);
            }
        });
}

export const getUserInfoByEmail = (
    email: string,
    onSuccess: (data: Tgcc.UserInfo) => void,
    onError: (error: string) => void
  ) => {
    request
      .post(apiRoot + 'Account/UserInfoByEmail') // Endpoint to handle fetching user info by email
      .send({ email }) // Include the email in the request body
      .end((err: any, res: any) => {
        if (err || !res.ok) {
          logError('getUserInfoByEmail: ', err || res.text);
          onError(err?.message || 'Failed to fetch user info');
        } else {
          onSuccess(res.body);
        }
      });
  };
  

export const changeUserPassword = (login: Tgcc.LoginData, oldPassword: string, newPassword: string, whenDone: () => void, onError: (err: any) => void) => {
    var data = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: newPassword
    }
    request.post(apiRoot + 'Account/ChangePassword')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || "Change password failed");
                logError("changePassword: ", err);
            } else {
                whenDone();
            }
        });
}

export const passwordResetRequest = (email: string, whenDone: () => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'Account/PasswordResetRequest')
        .type('application/json')
        .send({ UserEmail: email })
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || "reset password request failed");
                logError("changePassword: ", err);
            } else {
                whenDone();
            }
        });
}

export const campusPasswordResetRequest = (email: string, whenDone: () => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'Account/CampusPasswordResetRequest')
        .type('application/json')
        .send({ UserEmail: email })
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || "reset password request failed");
                logError("changePassword: ", err);
            } else {
                whenDone();
            }
        });
}

export const passwordReset = (token: string, email: string, newPassword: string, whenDone: () => void, onError: (err: any) => void) => {
    console.log('passwordReset function called with:', {
        token: token,
        tokenLength: token ? token.length : 0,
        email: email
    });
    
    request.post(apiRoot + 'Account/PasswordReset')
        .type('application/json')
        .send({ UserEmail: email, Token: token, NewPassword: newPassword })
        .end((err: any, res: any) => {
            if (err) {
                console.log('Password reset error details:', {
                    status: err.status,
                    response: err.response,
                    body: err.response ? err.response.body : null,
                    message: err.message
                });
                
                const errorMsg = extractErrorMsg(err);
                console.log('Extracted error message:', errorMsg);
                
                onError(errorMsg || "reset password failed");
                logError("changePassword: ", err);
            } else {
                console.log('Password reset successful');
                whenDone();
            }
        });
}

export const canImpersonate = (token: string, email: string, onSuccess: () => void, onError: (err: string) => void) => {
    request.post(apiRoot + 'Account/CanImpersonate')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + token })
        .set({ 'impersonate': email })
        .end((err: any, res: any) => {
            if (err) {
                onError(extractErrorMsg(err) || 'Cannot impersonate ' + email);
            } else {
                onSuccess();
            }
        });
}

//////////////////////// Proof API Routes //////////////////////////////

const jsonProofData = (email: string, proof: Tgcc.Proof) => {
    var data = {
        userEmail: email,
        proofId: proof.proofId,
        eventName: proof.eventName,
        inHandsDate: proof.inHandsDate,
        minOrderSize: proof.orderSize,
        backText: proof.text.back,
        backLocation: proof.backLocation,
        frontText: proof.text.front,
        frontLocation: proof.frontLocation,
        productStyle: proof.product ? proof.product.style : null,
        productBrand: proof.product ? proof.product.brand : null,
        productColor: proof.product ? proof.product.colorName : null,
        designId: proof.design ? proof.design.id : null,
        notes: proof.notes,
        PreviousPurchases: proof.previousPurchases,
        timeSensitive: proof.timeSensitive ? true : false,
        screenPrint: proof.screenPrint ? true : false,
        embroidery: proof.embroidery ? true : false,
        uploadedFiles: null,
        phone: proof.phone,
        smsAllowed: proof.smsAllowed,
        division:proof.division,
        salescontact:proof.salescontact,
        requestType:proof.requesttype,
        status: proof.status
    };

    if (proof.uploadedFiles) {
        var files = new Array();
        Object.keys(proof.uploadedFiles).forEach((key: string) => {
            files.push(proof.uploadedFiles[key]);
        });
        data.uploadedFiles = files.join(",");
    }
    return data;
}

export const updateProofRequest = (user: string, login: Tgcc.LoginData, proof: Tgcc.Proof, onSuccess: () => void, onError: (err: any) => void) => {
    var proofData = jsonProofData(user, proof);
    request.post(apiRoot + 'proofs/update')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(proofData)
        .end((err: any, res: any) => {
            if (err) {
                logError("updateProofRequest:", err);
                onError(extractErrorMsg(err) || "Update proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const createProofRequest = (email: string, login: Tgcc.LoginData, proof: Tgcc.Proof, onSuccess: (proof: Tgcc.Proof) => void, onError: (err: any) => void) => {
    var proofData = jsonProofData(email, proof);
    request.post(apiRoot + 'proofs/create')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(proofData)
        .end((err: any, res: any) => {
            if (err) {
                logError("createProofRequest:", err);
                onError(extractErrorMsg(err) || "Error creating proof request")
            } else {
                // Dispatch custom event
                const event = new CustomEvent('proofSubmittedEvent', { detail: { email, proof } });
                window.dispatchEvent(event);

                onSuccess(res.body);
            }
        });
}

export const createCampusProofRequest = (email: string, login: Tgcc.LoginData, proof: Tgcc.Proof, onSuccess: (proof: Tgcc.Proof) => void, onError: (err: any) => void) => {
    var proofData = jsonProofData(email, proof);
    request.post(apiRoot + 'proofs/campuscreate')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(proofData)
        .end((err: any, res: any) => {
            if (err) {
                logError("createProofRequest:", err);
                onError(extractErrorMsg(err) || "Error creating proof request")
            } else {
                // Dispatch custom event
                const event = new CustomEvent('proofSubmittedEvent', { detail: { email, proof } });
                window.dispatchEvent(event);

                onSuccess(res.body);
            }
        });
}


export const createGhostProof = (userData: Tgcc.UserInfo, loginData: Tgcc.LoginData, onSuccess: (proof: Tgcc.Proof) => void, onError: (err: any) => void) => {
    
    const ghostProofData = {
        userEmail: userData.email,
        status: 'Archived', // Assuming 'Archived' is a valid status for ghost proofs
    };

    // Convert your ghost proof data to JSONad
    const jsonData = JSON.stringify(ghostProofData);

    request.post(apiRoot + 'proofs/createGhost')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + loginData.token })
        .send(jsonData)
        .end((err: any, res: any) => {
            if (err) {
                logError("createGhostProof:", err);
                onError(extractErrorMsg(err) || "Error creating ghost proof");
            } else {
                onSuccess(res.body);
            }
        });
};

export const createCatalogRequest = (
    email: string,
    login: Tgcc.LoginData,
    proof: Tgcc.Proof
  ): Promise<Tgcc.Proof> => {
    const proofData = jsonProofData(email, proof) as any;
    if ((proof as any).apparelItems) proofData.apparelItems = (proof as any).apparelItems;
    if ((proof as any).designs) proofData.designs           = (proof as any).designs;
    if ((proof as any).previousPurchases) proofData.PreviousPurchases = (proof as any).previousPurchases;
    if ((proof as any).uploadedFiles) {
        const uploaded = (proof as any).uploadedFiles;
        proofData.uploadedFiles = typeof uploaded === 'string'
          ? uploaded
          : Object.values(uploaded).join(',');
      }
      
  
    return request
      .post(apiRoot + 'proofs/catalogcreate')
      .type('application/json')
      .set('Authorization', 'Bearer ' + authToken)
      .set('impersonate', login.impersonate)
      .send(proofData)
      .then(res => {
        if (!res.ok) {
          // try to pull meaningful JSON error
          const msg = res.body?.message || `Error ${res.status}`;
          return Promise.reject(msg);
        }
        return res.body as Tgcc.Proof;
      })
      .catch(err => {
        // normalize Superagent or thrown string
        const msg = typeof err === 'string' ? err : err.message || 'Unknown error';
        return Promise.reject(msg);
      });
  };
  
export const createDtdSampleRequest = (
    login: Tgcc.LoginData,
    payload: {
        proofId?: string;
        printDimensions: string;
        quantity: number;
        colorNotes?: string;
        additionalNotes?: string;
        csrEmail?: string;
        uploadedFiles?: { [filename: string]: string } | string;
    }
): Promise<Tgcc.Proof> => {
    const requestPayload = Object.assign({}, payload);
    if (requestPayload.uploadedFiles && typeof requestPayload.uploadedFiles !== 'string') {
        requestPayload.uploadedFiles = Object.values(requestPayload.uploadedFiles).join(',');
    }

    return request
        .post(apiRoot + 'proofs/dtdsamplecreate')
        .type('application/json')
        .set('Authorization', 'Bearer ' + authToken)
        .set('impersonate', login.impersonate)
        .send(requestPayload)
        .then(res => {
            if (!res.ok) {
                const msg = res.body?.message || `Error ${res.status}`;
                return Promise.reject(msg);
            }
            return res.body as Tgcc.Proof;
        })
        .catch(err => {
            const msg = typeof err === 'string' ? err : err.message || 'Unknown error';
            return Promise.reject(msg);
        });
};

  
export const createWebstoreRequest = (email: string, login: Tgcc.LoginData, proof: Tgcc.Proof, onSuccess: (proof: Tgcc.Proof) => void, onError: (err: any) => void) => {
    var proofData = jsonProofData(email, proof);
    request.post(apiRoot + 'proofs/webstorecreate')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(proofData)
        .end((err: any, res: any) => {
            if (err) {
                logError("createWebstoreRequest:", err);
                onError(extractErrorMsg(err) || "Error creating webstore request")
            } else {
                onSuccess(res.body);
            }
        });
}

export const getActiveProofs = (login: Tgcc.LoginData, onSuccess: (proofs: Tgcc.Proof[]) => void, onError: (err: any) => void) => {
    request.get(apiRoot + 'proofs/active')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("getActiveProofs:", err);
                onError(extractErrorMsg(err) || "Error getting active proofs");
            } else {
                onSuccess(res.body);
            }
        });
}

export const fetchImageUrlsFromBlob = (proofId: string, onSuccess: (images: string[]) => void, onError: (err: any) => void) => {
    const cleanProofId = proofId.replace(/^WO/, '');
    const requestUri = `${apiRoot}proofs/images/${cleanProofId}`;
    
 
    request.get(requestUri)
        .type('application/json')
        .end((err: any, res: any) => {
            if (err || !res.ok) {
                console.error('Error fetching proof images:', err);
                if (onError) {
                    onError(extractErrorMsg(err) || "Error fetching proof images");
                }
            } else {
                onSuccess(res.body);
            }
        });
};

export const fetchPapaJohnsDesignsFromBlob = (path, onSuccess, onError) => {
    const requestUri = `${apiRoot}designs/images/${path}`;
    
    request.get(requestUri)
        .type('application/json')
        .end((err, res) => {
            if (err || !res.ok) {
                console.error(`Error fetching designs:`, err);
                if (onError) {
                    onError("Error fetching designs");
                }
            } else {
                onSuccess(res.body); // Expecting the body to be an array of image URLs
            }
        });
};


export const getProofHistory = (login: Tgcc.LoginData, onSuccess: (proofs: Tgcc.Proof[]) => void, onError: (err: any) => void) => {
    request.get(apiRoot + 'proofs/history')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("getProofHistory:", err);
                onError(extractErrorMsg(err) || "Error getting proof history");
            } else {
                onSuccess(res.body);
            }
        });
}


export const getProof = (login: Tgcc.LoginData, proofId: string, onSuccess: (proof: Tgcc.Proof | null, status?: number) => void, onError: (err: any) => void) => {
    request.get(apiRoot + 'proofs/get/' + proofId)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("getProof:", err);
                onError(extractErrorMsg(err) || "Error getting proof history");
            } else {
                // Check for 204 No Content status
                if (res.status === 204) {
                    onSuccess(null, 204);
                } else {
                    onSuccess(res.body);
                }
            }
        });
}


// no login data needed for size inputs....not currently being used

export const getOneProof = (proofId: string, onSuccess: (proof: Tgcc.Proof) => void, onError: (errr: any) => void) => {
    request.get(apiRoot + 'proofs/getOne/' + proofId)
        .type('application/json')
        .end((err: any, res: any) => {
            if (err) {
                logError("get One Proof:", err);
                onError(extractErrorMsg(err) || "Error getting proof");
            } else {
                onSuccess(res.body)
            }
        })
}
//not currently being used
export const getSizes = (brand?: string, style?: string, colorName?: string, onSuccess?: (products: Tgcc.Product[]) => void, onError?: (err: string) => void) => {

    request('GET', apiRoot + 'products/brand/' + encodeBrand(brand) + '/style/' + encodeURI(style) + '/color/' + encodeColor(colorName) + '/sizes')
        .end((err: any, res: any) => {
            if (err)
                onError(extractErrorMsg(err))
            else
                onSuccess(res.body);
        });
}
//need to add TshirtChair 
//need to add Date not sure which one to use status date or order date
export const approveProof = (login: Tgcc.LoginData, proof: Tgcc.Proof, paymentConfig: Tgcc.PaymentConfig, userInfo: Tgcc.UserInfo, onSuccess: () => void, onError: (err: any) => void) => {

    //all data for all the payment options
    // compute rush based on inHandsDate within next 5 days (inclusive) and not in the past
    const today = new Date();
    today.setHours(0,0,0,0);
    const fiveDays = new Date(today.getTime());
    fiveDays.setDate(fiveDays.getDate() + 5);
    let rush = false;
    if (proof && proof.inHandsDate && proof.inHandsDate.length === 10) {
        const inHands = new Date(proof.inHandsDate);
        rush = inHands >= today && inHands <= fiveDays;
    }

    var data = {
        proofId: proof.proofId,
        rosterType: paymentConfig.type,
        closeRosterDate: paymentConfig.closeRosterDate,
        freeTshirt: paymentConfig.shirtSize,
        fullName: userInfo.firstName + " " + userInfo.lastName,
        userEmail: userInfo.email,
        organization: userInfo.organization,
        IsSpecialCase: paymentConfig.IsSpecialCase,
        school: userInfo.schoolOrBusiness,
        phone: userInfo.phone,
        eventName: proof.eventName,
        treasurerFullName: paymentConfig.trFirstName + " " + paymentConfig.trLastName,
        treasurerEmail: paymentConfig.trEmail,
        omegaNum: paymentConfig.omegaAcctNum,
        shippingAddress: paymentConfig.address,
        shippingCity: paymentConfig.city,
        shippingState: paymentConfig.State,
        shippingZipCode: paymentConfig.zipcode,
        classicPaymentType: paymentConfig.classicPaymentType,
        quantity: paymentConfig.quantity,
        xsmall: paymentConfig.XSmall,
        small: paymentConfig.Small,
        medium: paymentConfig.Medium,
        large: paymentConfig.Large,
        xLarge: paymentConfig.XLarge,
        xXL: paymentConfig.XXL,
        xXXL: paymentConfig.XXXL,
        xXXXL: paymentConfig.XXXXL,
        xXXXXL: paymentConfig.XXXXXL,
        xXXXXXL: paymentConfig.XXXXXXL,
        yXSmall: paymentConfig.YXSmall,
        ySmall: paymentConfig.YSmall,
        yMedium: paymentConfig.YMedium,
        yLarge: paymentConfig.YLarge,
        yXLarge: paymentConfig.YXLarge,
        todder2: paymentConfig.Toddler2,
        todder3: paymentConfig.Toddler3,
        todder4: paymentConfig.Toddler4,
        todder5: paymentConfig.Toddler5,
        todder6: paymentConfig.Toddler6,
        todder7: paymentConfig.Toddler7,
        infant6: paymentConfig.Infant6,
        infant12: paymentConfig.Infant12,
        infant18: paymentConfig.Infant18,
        infant24: paymentConfig.Infant24,
        oneSize: paymentConfig.OneSize,
        shipmentType: paymentConfig.shipmentType,
        inHandsDate: proof.inHandsDate,
        rush: rush
    };

    request.post(apiRoot + 'proofs/approve')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                logError("approveProof:", err);
                onError(extractErrorMsg(err) || "Approve proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const submitShippingAndBillingDetails = (loginData, details, onSuccess, onError) => {
    request.post(apiRoot + 'proofs/submitDetails') // Adjust the endpoint as necessary
        .set({ 'Authorization': 'Bearer ' + loginData.token })
        .send(details)
        .end((err, res) => {
            if (err || !res.ok) {
                console.error("Failed to submit shipping and billing details:", err);
                onError(err);
            } else {
                console.log("Shipping and billing details submitted successfully:", res.body);
                onSuccess(res.body);
            }
        });
};

export const approveIndigoProof = (login: Tgcc.LoginData, proofId: string, onSuccess: () => void, onError: (err: any) => void) => {

    request.post(apiRoot + 'proofs/approveProof/' + proofId)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("approveProof:", err);
                onError(extractErrorMsg(err) || "Approve proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const cancelProof = (login: Tgcc.LoginData, proofId: string, onSuccess: () => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'proofs/cancel/' + proofId)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("cancelProof:", err);
                onError(extractErrorMsg(err) || "Cancel proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const initProof = (): Promise<string> => {
    return new Promise((resolve, reject) => {
      request
        .post(apiRoot + "proofs/init")
        .type("application/json")
        .end((err: any, res: any) => {
          if (err) {
            console.error("initproof:", err);
            reject(extractErrorMsg(err) || err);
          } else {
            resolve(res.text);
          }
        });
    });
  };
export const reviseProof = (login: Tgcc.LoginData, proofId: string, notes: string, uploads: string[], onSuccess: () => void, onError: (err: any) => void) => {
    var data = {
        proofId: proofId,
        notes: notes,
        uploadedFilesString: uploads.join(',')
    };

    request.post(apiRoot + 'proofs/revise')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                logError("reviseProof:", err);
                onError(extractErrorMsg(err) || "Revise proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const reviseProofByCsr = (login: Tgcc.LoginData,proofId: string, notes: string, uploads: string[], onSuccess: () => void, onError: (err: any) => void) => {
    var data = {
        proofId: proofId,
        notes: notes,
        uploadedFilesString: uploads.join(',')
    };

    request.post(apiRoot + 'proofs/revisebycsr')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                logError("reviseProof:", err);
                onError(extractErrorMsg(err) || "Revise proof request failed");
            } else {
                onSuccess();
            }
        });
}

export const getRoster = (login: Tgcc.LoginData, rosterCode: string, onSuccess: (roster: any) => void, onError: (err: string) => void) => {

    console.log('getRoster request')
    request.get(apiRoot + 'proofs/roster/' + rosterCode)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                if (res && res.status === 401) {
                    onError("Unauthorized access: You do not have permission to view this roster.");
                } else {
                    logError("getOrderRoster:", err);
                    onError(extractErrorMsg(err) || "getRoster failed");
                }
            } else {
                onSuccess(res.body);
            }
        });
}

export const closeTBankerRoster = (login: Tgcc.LoginData, rosterCode: string, onSuccess: () => void, onError: (err: string) => void) => {
    request.post(apiRoot + 'proofs/roster/tbanker/close/' + rosterCode)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("close TBanker Roster:", err);
                onError(extractErrorMsg(err) || "Tbanker roster not found");
            } else {
                onSuccess();
            }
        });
}

export const closeTViteRoster = (login: Tgcc.LoginData, rosterCode: string, onSuccess: () => void, onError: (err: string) => void) => {
    request.post(apiRoot + 'proofs/roster/tvite/close/' + rosterCode)
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("close TVite roster:", err);
                onError(extractErrorMsg(err) || "TVite roster not found");
            } else {
                onSuccess();
            }
        });
}

export const getTbanker = (proofId: string, onSuccess: (info: Tgcc.TbankerInfo) => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'tbanker/get')
        .type('application/json')
        .send({ proofId: proofId })
        .end((err: any, res: any) => {
            if (err) {
                logError("getTbanker:", err);
                onError(extractErrorMsg(err) || "Tbanker not found");
            } else {
                onSuccess(res.body);
            }
        });
}

export const getTvite = (proofId: string, onSuccess: (info: Tgcc.TbankerInfo) => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'tvite/get')
        .type('application/json')
        .send({ proofId: proofId })
        .end((err: any, res: any) => {
            if (err) {
                logError("getTvite:", err);
                onError(extractErrorMsg(err) || "Tvite not found");
            } else {
                onSuccess(res.body);
            }
        });
}

// Adjusted to take a single object parameter
export const orderTvite = ({
    tvCode, 
    proofId, 
    organization = '', // Default to an empty string if not provided
    firstName, 
    lastName, 
    email,
    phoneNumber, // Add this line
    quantity, 
    individualShip, 
    addr1, 
    addr2, 
    city, 
    state, 
    zip,
    oneSizeQuantity,
    onSuccess, 
    onError,
    ...sizes // Here, sizes should be part of the parameter list, not nested inside it.
}) => {
    const data = {
        tbCode: tvCode,
        proofId: proofId,
        organization: organization,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phoneNumber: phoneNumber,
        quantity: quantity,
        individualShip: individualShip,
        address1: addr1,
        address2: addr2,
        city: city,
        state: state,
        zip: zip,
        oneSizeQuantity: oneSizeQuantity,
        ...sizes // Spread the sizes directly into the data object
    };

    request.post(`${apiRoot}tvite/order`)
        .send(data)
        .then(res => onSuccess(res.body))
        .catch(err => onError(err.response.body));
};



////////////////////////   FILE UPLOAD ROUTES //////////////////////

export const uploadFile = (proofId: string, file: File, onSuccess: (url: string) => void, onError: (err: string) => void) => {
    request.post(apiRoot + 'proofs/upload/' + proofId)
        .attach('uploadedFile', file as any)
        .end((err: any, res: any) => {
            if (err) {
                logError("uploadFile:", err);
                onError(extractErrorMsg(err) || "Upload failed. Call (800)472-3269 for assistance.");
            } else {
                onSuccess(res.text);
            }
        });
}

export const uploadCampusFile = (
    proofId: string,
    file: File,
    onSuccess: (url: string) => void,
    onError: (err: string) => void
  ): void => {
    request
      .post(`${apiRoot}proofs/campusupload/${proofId}`)
      .attach('uploadedFile', file as any) 
      .end((err: any, res: any) => {
        if (err) {
          logError("uploadCampusFile:", err);
          onError(extractErrorMsg(err) || "Upload failed. Call (800)472-3269 for assistance.");
        } else {
          onSuccess(res.text);
        }
      });
  };
  
export const deleteUpload = (proofId: string, uploadUrl: string) => {

    // this is a best effort issue.
    // just marke the file as deleted on the server
    // no confirmation
    request.post(apiRoot + 'proofs/deleteupload')
        .send({ proofId: proofId, UploadUrl: uploadUrl })
        .end((err: any, res: any) => {
            if (err) {
                logError("deleteUpload:", err);
            }
        });
}

export const fetchPapaJohnsShirtOfMonth = (
    onSuccess: (shirtDetails: any) => void, // Adjust the type of `shirtDetails` based on what your endpoint returns
    onError: (err: string) => void
  ) => {
    request.get(apiRoot + 'tvite/current-shirt')
      .end((err: any, res: any) => {
        if (err) {
          console.error("fetchPapaJohnsShirtOfMonth: Error fetching current shirt of the month", err);
          onError(extractErrorMsg(err));
        } else {
          console.log("fetchPapaJohnsShirtOfMonth: Success", res.body);
          onSuccess(res.body);
        }
      });
  };

export const fetchCurrentCedTvite = (
    onSuccess: (details: { url: string }) => void,
    onError: (err: string) => void
  ) => {
    request.get(apiRoot + 'tvite/current-ced')
      .end((err: any, res: any) => {
        if (err) {
          console.error('fetchCurrentCedTvite: Error fetching current CED T-Vite', err);
          onError(extractErrorMsg(err));
        } else {
          onSuccess(res.body);
        }
      });
  };


////////////////////// Braintree Payment API /////////////////////////////////
export const processBraintreePayment = (nonce: string, deviceData: any, tbCode: string, proofId: string, quantity: number, sizes: Tgcc.SizesRec,  checkout: Tgcc.Checkout, onSuccess: (id: string) => void, onError: (err: any) => void) => {

    var data = Object.assign({
        Nonce: nonce,
        DeviceData: deviceData,
        TbCode: tbCode,
        proofId: proofId,
        Code: tbCode,
        Quantity: quantity,
        FirstName: checkout.FirstName,
        LastName: checkout.LastName,
        Email: checkout.Email,
        Organization: checkout.Organization,
        IndividualShip: checkout.IndividualShip,
        AddrLine1: checkout.AddrLine1,
        AddrLine2: checkout.AddrLine2,
        AddrCity: checkout.AddrCity,
        AddrState: checkout.AddrState,
        AddrZip: checkout.AddrZip,
    }, sizes);

    request.post(apiRoot + 'tbanker/braintreepayment')
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                console.log("processBriantreePayment:", err);
                onError(extractErrorMsg(err));
            } else {
                onSuccess(res.body);
            }
        });
}

export const processWebshopBraintreePayment = (nonce: string, deviceData: any, cartItems: Tgcc.WebStoreCartItemModel[], checkout: Tgcc.Checkout, onSuccess: (id: string) => void, onError: (err: any) => void) => {
    var data = {
        Nonce: nonce,
        DeviceData: deviceData,
        CartItems: cartItems,
        Checkout: checkout,
    };

    request.post(apiRoot + 'webstore/braintreepayment')
        .send(data)
        .end((err: any, res: any) => {
            if (err) {
                console.log("webstore/braintreepayment:", err);
                onError(extractErrorMsg(err));
            } else {
                onSuccess(res.body);
            }
        });
}

////////////////////// Schools API /////////////////////////////////
export const getSchools = (whenDone: (schools: string[]) => void) => {
    request('GET', apiRoot + 'proofs/schools').end((err: any, res: any) => {
        if (!err)
            whenDone(res.body);
    }
    );
};


///Send Feedback Form///
export const sendFeedback = (feedback: Tgcc.Feedback, onSuccess: () => void,) => {
    request.post(apiRoot + 'messages/feedback')
        .type('application/json')
        .send(feedback)
        .end((err: any, res: any) => {
            if (err) {
                logError("Feedback Failed:", err);
            } else {
                onSuccess();
            }
        })
};
///Send Contact US Form///
export const sendContactUS = (contactUs: Tgcc.ContactUs, onSuccess: () => void,) => {
    request.post(apiRoot + 'messages/contactus')
        .type('application/json')
        .send(contactUs)
        .end((err: any, res: any) => {
            if (err) {
                logError("Contact Us Failed:", err);
            } else {
                onSuccess();
            }
        })
};

///Send Lead Form///
export const sendLead = (lead: Tgcc.Lead, onSuccess: () => void,) => {
    request.post(apiRoot + 'messages/lead')
        .type('application/json')
        .send(lead)
        .end((err: any, res: any) => {
            if (err) {
                logError("Lead Failed:", err);
            } else {
                onSuccess();
            }
        })
};

///Send School Request Form///
export const sendSchoolRequest = (schoolRequest: Tgcc.SchoolRequest, onSuccess: () => void,) => {
    request.post(apiRoot + 'messages/schoolrequest')
        .type('application/json')
        .send(schoolRequest)
        .end((err: any, res: any) => {
            if (err) {
                logError("School Request Failed:", err);
            } else {
                onSuccess();
            }
        })
};

/////////////////// Merchandising API requests /////////////////////////
export const getMerchandising = (division: string, theme: string, whenDone: (items: Tgcc.MerchBinding[]) => void) => {

    var requestUrl = apiRoot + 'merch';
    if (division) {
        requestUrl += '/division/' + division;
        if (theme)
            requestUrl += '/theme/' + theme;
    }

    request('GET', requestUrl).end((err: any, res: any) => {
        if (err) {
            logError('GetMerchandising Failed:', err);
        }
        else {
            whenDone(res.body);
        }
    });
};

export const getMerchandisingTheme = (division: string, theme: string, whenDone: (items: Tgcc.MerchandisingTheme) => void) => {

    var requestUrl = apiRoot + 'merch/themes';
    if (division) {
        requestUrl += '/division/' + division;
        if (theme)
            requestUrl += '/theme/' + theme;
    }

    request('GET', requestUrl).end((err: any, res: any) => {
        if (err) {
            logError('GetMerchandisingTheme Failed:', err);
        }
        else {
            whenDone(res.body);
        }
    });
};

export const getMerchandisingThemes = (division: string, whenDone: (items: Tgcc.MerchandisingTheme[]) => void) => {

    var requestUrl = apiRoot + 'merch/themes';
    if (division) {
        requestUrl += '/division/' + division + '/themes';
    }

    request('GET', requestUrl).end((err: any, res: any) => {
        if (err) {
            logError('GetMerchandisingTheme Failed:', err);
        }
        else {
            whenDone(res.body);
        }
    });
};


/////////////////////////  address verification ////////////////////////////

export const verifyAddress = (addr1: string, addr2: string, city: string, state: string, zip: string, onSuccess: (address: Tgcc.AddressVerifyModel) => void, onError: (err: any) => void) => {
    request.post(apiRoot + 'address/verify')
        .type('application/json')
        .send({
            Addr1: addr1,
            Addr2: addr2,
            City: city,
            State: state,
            Zip: zip
        })
        .end((err: any, res: any) => {
            if (err) {
                logError("verifyAddress:", err);
                onError(extractErrorMsg(err) || "Error verifying address");
            } else {
                onSuccess(res.body);
            }
        });
}

/////////////////////////////  get TBanker Closing date ////////////////////////

export const fetchClosingDate = (webOrder, endpoint, onSuccess, onError) => {
    const url = `${apiRoot}${endpoint}/${webOrder}`;
    console.log("Requesting URL:", url); // Log the URL for debugging
    request.get(url)
      .type('application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.error('Error fetching closing date:', err);
          onError(err);
        } else {
          // Check if the status code is 204 No Content
          if (res.status === 204) {
            onSuccess(null); // Call onSuccess with null to indicate no closing date
          } else {
            const closingDate = new Date(res.body);
            onSuccess(closingDate); // Call onSuccess with the closing date
          }
        }
      });
  };
///////////////////////////// webstore requests ////////////////////////

export const getWebStore = (storeId: string, onSuccess: (webStoreModel: Tgcc.WebStore) => void, onError: (err: any) => void) => {
    request.get(apiRoot + 'webstore/get/' + storeId)
        .type('application/json')
        .end((err: any, res: any) => {
            if (err) {
                onError(err);
            } else {
                onSuccess(res.body);
            }
        });
}

export const updateProofConfirmationEmailPreference = (
    login: Tgcc.LoginData,
    email: string,
    enabled: boolean,
    whenDone: () => void,
    onError: (err: any) => void
) => {
    request.post(apiRoot + 'Account/UpdateProofConfirmationEmailPreference')
        .type('application/json')
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .send({ email, enabled })
        .end((err: any, res: any) => {
            if (err) {
                logError("updateProofConfirmationEmailPreference: ", err);
                onError(extractErrorMsg(err) || "Failed to update proof confirmation email preference");
            } else {
                whenDone();
            }
        });
}

export const getProofConfirmationEmailPreference = (
    login: Tgcc.LoginData,
    email: string,
    whenDone: (data: { email: string, proofConfirmationEmailsEnabled: boolean }) => void,
    onError: (err: any) => void
) => {
    request.get(`${apiRoot}Account/GetProofConfirmationEmailPreference?email=${encodeURIComponent(email)}`)
        .set({ 'Authorization': 'Bearer ' + authToken })
        .set({ 'impersonate': login.impersonate })
        .end((err: any, res: any) => {
            if (err) {
                logError("getProofConfirmationEmailPreference: ", err);
                onError(extractErrorMsg(err) || "Failed to get proof confirmation email preference");
            } else {
                whenDone(res.body);
            }
        });
}
